import React, { FC, memo } from 'react';

import usePrefix from 'utils/usePrefix';
import TextAreaComponent from 'components/TextAreaComponent';

interface Props {
  id: string;
  value: string;
  onChange: (value: string) => void;
  limit?: number;
  label?: string;
}

const ExpertNote: FC<Props> = ({ id, value, onChange, limit, label }) => {
  const t = usePrefix('ResqlExpert');
  const resolvedLabel = label ?? t('expert_note_label');

  return (
    <TextAreaComponent
      id={id}
      label={resolvedLabel}
      limit={limit}
      placeholder={t('expert_note_placeholder')}
      text={value}
      setText={onChange}
    />
  );
};

export default memo(ExpertNote);
